import React, { useState, useEffect } from 'react';
import axios from "axios";
import '../styles/footer.css';
import AppStore from '../images/appstore.png';
import PlayStore from '../images/playstore.png';

const Footer = ({ title = null }) => {
  const [metaData, setMetaData] = useState([{}]); // ✅ Safe default
  const [expanded, setExpanded] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const get_meta = async () => {
    const currentPath = window.location.pathname;
    const fullUrl = `https://alahdeen.com${currentPath}`;
    console.log("🔎 Fetching metadata for:", fullUrl);

    try {
      const response = await axios.post(
        "/pro/seo/get_meta.php",
        { url: fullUrl },
        { headers: { "Content-Type": "application/json" } }
      );

      if (Array.isArray(response.data) && response.data.length > 0) {
        setMetaData(response.data);
        console.log("✅ Metadata fetched:", response.data[0]);
      } else {
        setMetaData([{ msg: "fail", code: "" }]); // ✅ Prevent undefined
        console.warn("⚠️ Empty metadata response", response.data);
      }
    } catch (error) {
      console.error("❌ Metadata fetch failed:", error);
      setMetaData([{ msg: "fail", code: "" }]); // ✅ Prevent crash
    }
  };

  const handleSubscribe = async () => {
    if (email) {
      const formData = new FormData();
      formData.append('email', email);

      try {
        const response = await axios.post('/pro/subscribe.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.success) {
          setIsSubscribed(true);
        } else {
          alert("Subscription failed. Please try again.");
        }
      } catch (error) {
        console.error("Error during subscription:", error);
        alert("An error occurred. Please try again.");
      }
    } else {
      alert('Please enter a valid email address');
    }
  };

  useEffect(() => {
      if(!window.isExcluded) {
        get_meta();
      }
  }, []);

  const meta = metaData[0] || {};

  return (
    <>
      <div className="container p-xs-2 p-md-0 my-4">
        {meta.code && meta.code !== '<p><br></p>' ? (
          <div className="footer-div px-md-4 discStyle">
            {meta.code.length > 1500 ? (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: expanded ? meta.code : meta.code.substring(0, 1500) + "..."
                  }}
                />
                <button
                  onClick={() => setExpanded(!expanded)}
                  className="custom-theme-button"
                >
                  {expanded ? "Read Less" : "Read More"}
                </button>
              </>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: meta.code }} />
            )}
          </div>
        ) : meta.code === '' && title ? (
          <div
            className="footer-div px-md-4 discStyle"
            dangerouslySetInnerHTML={{
              __html: `
<h1>The Leading B2B Marketplace For Buyers</h1>
<span style="font-family:'Roboto', sans-serif; color:#868e96" class="extra-content">
  Alahdeen helps businesses partner with the right <h1 class="inline-h1">${title}</h1> suppliers from different regions of Pakistan, and more. This gives you an opportunity to explore a vast range of options including <h1 class="inline-h1">${title}</h1> and the list goes on. With all these options available on Alahdeen, you can always get the best deals despite your order size, frequency, or packaging requirements.
</span>

<h2>Avail the Best Deals on ${title}</h2>
<span style="font-family:'Roboto', sans-serif; color:#868e96" class="extra-content">
  Our mission as a B2B marketplace is to make sourcing fast and simple for local businesses in Pakistan by partnering with <h1 class="inline-h1">${title}</h1> suppliers who offer the market's best prices. Affordable <h1 class="inline-h1">${title}</h1> prices with great quality are the reason why most businesses prefer Alahdeen for bulk procurement. We also welcome you to sign up for free and avail great deals now.
</span>

<h2>Don’t Wait! Get the Latest Products With Us</h2>
<span style="font-family:'Roboto', sans-serif; color:#868e96" class="extra-content">
  People interested in <h1 class="inline-h1">${title}</h1> also search for other products. We welcome you to check our latest selection for these goods and keep your stock updated with the finest products available in the market. Sign up for free and connect with top <h1 class="inline-h1">${title}</h1> suppliers now.
</span>` }}
          />
        ) : null}
      </div>

      {/* The rest of your footer remains unchanged */}
      <section className="footer-container">
      <div className='container pb-5'>
      <div className='row d-flex justify-content-start py-5'>
        <div className='col-12 col-sm-6 col-lg-3'>
          <span className='fs-5 font-bold d-inline-block mb-4 footer-heading'>Contact</span>
          <p className='footer-text'><span className="font-bold">Address:</span> <span>  43-C, D.H.A Phase II Extension Phase 2, Karachi, Pakistan</span></p>
          <p className='footer-text'>
            <span className='font-bold'>Phone:</span> 
            <a href="tel:+922137295237">
              <span>(+92) 021-372-95237</span>
            </a>
          </p>

          <p className='footer-text'>
            <span className='font-bold'>E-mail:</span> 
            <a href="mailto:info@alahdeen.com">
              <span>info@alahdeen.com</span>
            </a>
          </p>


          <div className='d-flex mt-2' style={{ gap: '.4rem' }}>
          {/* Facebook Icon and Link */}
          <a href="https://www.facebook.com/@alahdeenb2b/?profile_tab_item_selected=about&_rdr" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f" style={{ fontSize: '32px', color: '#3b5998' }}></i>
          </a>

          {/* Instagram Icon and Link */}
          <a href="https://www.facebook.com/@alahdeenb2b/?profile_tab_item_selected=about&_rdr" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram" style={{ fontSize: '32px', color: '#E1306C' }}></i>
          </a>

          {/* LinkedIn Icon and Link */}
          <a href="https://pk.linkedin.com/in/alahdeenb2b?trk=people_directory" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in" style={{ fontSize: '32px', color: '#0077B5' }}></i>
          </a>

          {/* YouTube Icon and Link */}
          <a href="https://www.youtube.com/@alahdeenb2b" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube" style={{ fontSize: '32px', color: '#FF0000' }}></i>
          </a>
        </div>

        </div>
        
        <div className='col-12 col-sm-6 col-lg-3'>
          <span className='fs-5 font-bold d-inline-block mb-4 footer-heading'>App & Payment</span>

          <p className='footer-text'>Download our Apps</p>

          <div className='d-flex'>
            <img className='img-fluid' style={{height:"40px", marginRight:"2px"}} src={AppStore} />
            <img className='img-fluid' style={{height:"40px"}} src={PlayStore} />
          </div>
        </div>

        <div className='col-12 col-sm-6 col-lg-3'>
        <span className='fs-5 font-bold d-inline-block mb-4 footer-heading'>Company</span>

        <p className='footer-text'>
          <a href='/blogs' className='d-flex align-items-center text-decoration-none text-dark'>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
              <g clipPath="url(#clip0_2_3210)">
                <g opacity="0.6">
                  <path d="M0.452148 2.00494L0.452149 6.15828V9.8983C0.452149 10.5383 1.22548 10.8583 1.67882 10.405L5.13215 6.95161C5.68549 6.39828 5.68549 5.49828 5.13215 4.94495L3.81882 3.63161L1.67882 1.49161C1.22548 1.04494 0.452148 1.36495 0.452148 2.00494Z" fill="#425A8B" />
                </g>
              </g>
            </svg>
            <span className='ml-2'>Our Blog</span>
          </a>
        </p>
        
        <p className='footer-text'>
          <a href='/subscription' className='d-flex align-items-center text-decoration-none text-dark'>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
              <g clipPath="url(#clip0_2_3210)">
                <g opacity="0.6">
                  <path d="M0.452148 2.00494L0.452149 6.15828V9.8983C0.452149 10.5383 1.22548 10.8583 1.67882 10.405L5.13215 6.95161C5.68549 6.39828 5.68549 5.49828 5.13215 4.94495L3.81882 3.63161L1.67882 1.49161C1.22548 1.04494 0.452148 1.36495 0.452148 2.00494Z" fill="#425A8B" />
                </g>
              </g>
            </svg>
            <span className='ml-2'>Plans & Pricing</span>
          </a>
        </p>

        <p className='footer-text'>
          <a href='/about-us' className='d-flex align-items-center text-decoration-none text-dark'>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
              <g clipPath="url(#clip0_2_3210)">
                <g opacity="0.6">
                  <path d="M0.452148 2.00494L0.452149 6.15828V9.8983C0.452149 10.5383 1.22548 10.8583 1.67882 10.405L5.13215 6.95161C5.68549 6.39828 5.68549 5.49828 5.13215 4.94495L3.81882 3.63161L1.67882 1.49161C1.22548 1.04494 0.452148 1.36495 0.452148 2.00494Z" fill="#425A8B" />
                </g>
              </g>
            </svg>
            <span className='ml-2'>About Us</span>
          </a>
        </p>
        <p className='footer-text'>
          <a href='/privacy-policy' className='d-flex align-items-center text-decoration-none text-dark'>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
              <g clipPath="url(#clip0_2_3210)">
                <g opacity="0.6">
                  <path d="M0.452148 2.00494L0.452149 6.15828V9.8983C0.452149 10.5383 1.22548 10.8583 1.67882 10.405L5.13215 6.95161C5.68549 6.39828 5.68549 5.49828 5.13215 4.94495L3.81882 3.63161L1.67882 1.49161C1.22548 1.04494 0.452148 1.36495 0.452148 2.00494Z" fill="#425A8B" />
                </g>
              </g>
            </svg>
            <span className='ml-2'>Privacy Policy</span>
          </a>
        </p>
        <p className='footer-text'>
          <a href='/delete-account' className='d-flex align-items-center text-decoration-none text-dark'>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
              <g clipPath="url(#clip0_2_3210)">
                <g opacity="0.6">
                  <path d="M0.452148 2.00494L0.452149 6.15828V9.8983C0.452149 10.5383 1.22548 10.8583 1.67882 10.405L5.13215 6.95161C5.68549 6.39828 5.68549 5.49828 5.13215 4.94495L3.81882 3.63161L1.67882 1.49161C1.22548 1.04494 0.452148 1.36495 0.452148 2.00494Z" fill="#425A8B" />
                </g>
              </g>
            </svg>
            <span className='ml-2'>Delete Account</span>
          </a>
        </p>
      </div>
        <div className='col-12 col-sm-6 col-lg-3'>
        <span className='fs-5 font-bold d-inline-block mb-4 footer-heading'>Subscribe to our Newsletter</span>
              {isSubscribed ? (
                <p className="footer-text">Thank you for subscribing!</p>
              ) : (
                <div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="form-control mb-2"
                  />
                  <button
                    onClick={handleSubscribe}
                    className="btn btn-primary"
                  >
                    Subscribe
                  </button>
                </div>
              )}
        </div>
      </div>
      </div>
    </section>
    </>
  );
};

export default Footer;
